module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reset-password background-color long-contents"
  }, [_c('app-header-noauth'), _c('div', {
    staticClass: "div text-center"
  }, [_c('div', {
    staticClass: "row margin-top"
  }), _c('div', {
    staticClass: "row margin-top"
  }), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "container text-center"
  }, [_c('div', {
    staticClass: "row text-center margin-top margin-left margin-right"
  }, [_c('span', [_c('label', {
    staticClass: "forgot-password-title"
  }, [_vm._v(_vm._s(_vm.$t('reset_password.input_new_password')))])]), _c('br'), _c('span', [_c('label', {
    staticClass: "forgot-password-title"
  }, [_vm._v(_vm._s(_vm.$t('reset_password.input_new_password_input')))])])]), _c('div', {
    staticClass: "row margin-top margin-left margin-right"
  }, [_c('div', {
    staticClass: "div center-block text-left"
  }, [_c('label', {
    staticClass: "col-xs-11 control-label margin-top margin-left margin-right"
  }, [_vm._v(_vm._s(_vm.$t('New Password')))]), _c('div', {
    staticClass: "col-xs-11 margin-left margin-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.password_rule
    },
    attrs: {
      "id": "password",
      "type": "password",
      "name": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.password_rule),
      expression: "!validation.password_rule"
    }],
    staticStyle: {
      "color": "#f44336"
    }
  }, [_vm._v("4文字以上10文字以下の英数字を入力してください。")])])])]), _c('div', {
    staticClass: "row margin-top margin-left margin-right"
  }, [_c('div', {
    staticClass: "div center-block text-left"
  }, [_c('label', {
    staticClass: "col-xs-11 control-label margin-top margin-left margin-right"
  }, [_vm._v(_vm._s(_vm.$t('New Password Retyped')))]), _c('div', {
    staticClass: "col-xs-11 margin-left margin-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password_retyped),
      expression: "password_retyped"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.password_retyped
    },
    attrs: {
      "id": "password",
      "type": "password",
      "name": "password_retyped"
    },
    domProps: {
      "value": (_vm.password_retyped)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password_retyped = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.password_retyped && _vm.password),
      expression: "!validation.password_retyped && password"
    }],
    staticStyle: {
      "color": "#f44336"
    }
  }, [_vm._v("同じパスワードを入力してください。")]), (_vm.showMessage) ? _c('div', {
    staticClass: "alert",
    class: {
      'alert-success': _vm.isResetPasswordSuccess, 'alert-danger': !_vm.isResetPasswordSuccess
    }
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e()])])]), _c('div', {
    staticClass: "row margin-top text-center"
  }, [_c('div', {
    staticClass: "col-xs-11 margin-left margin-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "text-center col-xs-12"
  }, [_c('a', {
    staticClass: "col-xs-12 btn btn-default btn-lg bg-success btn-gradation",
    class: {
      disabled: !_vm.validation.not_input
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('span', {
    staticClass: "login-btn"
  }, [_vm._v(_vm._s(_vm.$t('reset_password.send')) + " ")]), _c('i', {
    staticClass: "fa fa-chevron-right",
    staticStyle: {
      "color": "white"
    }
  })])])]), _c('div', {
    staticClass: "form-group"
  }, [(!_vm.isResetPasswordSuccess) ? _c('span', [_vm._v(_vm._s(_vm.$t('reset_password.reset_cancel.message1'))), _c('br')]) : _vm._e(), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('u', {
    staticClass: "span"
  }, [_vm._v(_vm._s(_vm.$t('reset_password.reset_cancel.message2')))])])], 1)])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-255b0986!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/reset-password.pug
// module id = 1399
// module chunks = 1